/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProductProfitabilityProductData } from './ProductProfitabilityProductData';
import {
    ProductProfitabilityProductDataFromJSON,
    ProductProfitabilityProductDataFromJSONTyped,
    ProductProfitabilityProductDataToJSON,
    ProductProfitabilityProductDataToJSONTyped,
} from './ProductProfitabilityProductData';
import type { ProductProfitabilitySummaryData } from './ProductProfitabilitySummaryData';
import {
    ProductProfitabilitySummaryDataFromJSON,
    ProductProfitabilitySummaryDataFromJSONTyped,
    ProductProfitabilitySummaryDataToJSON,
    ProductProfitabilitySummaryDataToJSONTyped,
} from './ProductProfitabilitySummaryData';

/**
 * 
 * @export
 * @interface ProductProfitabilityData
 */
export interface ProductProfitabilityData {
    /**
     * 
     * @type {ProductProfitabilitySummaryData}
     * @memberof ProductProfitabilityData
     */
    summary?: ProductProfitabilitySummaryData;
    /**
     * 
     * @type {Array<ProductProfitabilityProductData>}
     * @memberof ProductProfitabilityData
     */
    products?: Array<ProductProfitabilityProductData>;
    /**
     * 
     * @type {Array<ProductProfitabilityProductData>}
     * @memberof ProductProfitabilityData
     */
    topProductsByProfit?: Array<ProductProfitabilityProductData>;
    /**
     * 
     * @type {Array<ProductProfitabilityProductData>}
     * @memberof ProductProfitabilityData
     */
    topProductsByAmount?: Array<ProductProfitabilityProductData>;
    /**
     * 
     * @type {number}
     * @memberof ProductProfitabilityData
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductProfitabilityData
     */
    limit?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductProfitabilityData
     */
    totalItems?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductProfitabilityData
     */
    totalPages?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductProfitabilityData
     */
    sourceTotalItems?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductProfitabilityData
     */
    loadedItems?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProductProfitabilityData
     */
    isTruncated?: boolean;
    /**
     * 
     * @type {ProductProfitabilityDataModeEnum}
     * @memberof ProductProfitabilityData
     */
    mode?: ProductProfitabilityDataModeEnum;
    /**
     * 
     * @type {ProductProfitabilityDataSortByEnum}
     * @memberof ProductProfitabilityData
     */
    sortBy?: ProductProfitabilityDataSortByEnum;
    /**
     * 
     * @type {string}
     * @memberof ProductProfitabilityData
     */
    marketingAllocationBasis?: string;
}


/**
 * @export
 */
export const ProductProfitabilityDataModeEnum = {
    Gross: 'gross',
    Net: 'net'
} as const;
export type ProductProfitabilityDataModeEnum = typeof ProductProfitabilityDataModeEnum[keyof typeof ProductProfitabilityDataModeEnum];

/**
 * @export
 */
export const ProductProfitabilityDataSortByEnum = {
    Product: 'product',
    ProfitAfterMarketing: 'profitAfterMarketing',
    GrossMargin: 'grossMargin',
    Turnover: 'turnover',
    Amount: 'amount',
    MarginPercent: 'marginPercent'
} as const;
export type ProductProfitabilityDataSortByEnum = typeof ProductProfitabilityDataSortByEnum[keyof typeof ProductProfitabilityDataSortByEnum];


/**
 * Check if a given object implements the ProductProfitabilityData interface.
 */
export function instanceOfProductProfitabilityData(value: object): value is ProductProfitabilityData {
    return true;
}

export function ProductProfitabilityDataFromJSON(json: any): ProductProfitabilityData {
    return ProductProfitabilityDataFromJSONTyped(json, false);
}

export function ProductProfitabilityDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductProfitabilityData {
    if (json == null) {
        return json;
    }
    return {
        
        'summary': json['summary'] == null ? undefined : ProductProfitabilitySummaryDataFromJSON(json['summary']),
        'products': json['products'] == null ? undefined : ((json['products'] as Array<any>).map(ProductProfitabilityProductDataFromJSON)),
        'topProductsByProfit': json['topProductsByProfit'] == null ? undefined : ((json['topProductsByProfit'] as Array<any>).map(ProductProfitabilityProductDataFromJSON)),
        'topProductsByAmount': json['topProductsByAmount'] == null ? undefined : ((json['topProductsByAmount'] as Array<any>).map(ProductProfitabilityProductDataFromJSON)),
        'page': json['page'] == null ? undefined : json['page'],
        'limit': json['limit'] == null ? undefined : json['limit'],
        'totalItems': json['totalItems'] == null ? undefined : json['totalItems'],
        'totalPages': json['totalPages'] == null ? undefined : json['totalPages'],
        'sourceTotalItems': json['sourceTotalItems'] == null ? undefined : json['sourceTotalItems'],
        'loadedItems': json['loadedItems'] == null ? undefined : json['loadedItems'],
        'isTruncated': json['isTruncated'] == null ? undefined : json['isTruncated'],
        'mode': json['mode'] == null ? undefined : json['mode'],
        'sortBy': json['sortBy'] == null ? undefined : json['sortBy'],
        'marketingAllocationBasis': json['marketingAllocationBasis'] == null ? undefined : json['marketingAllocationBasis'],
    };
}

export function ProductProfitabilityDataToJSON(json: any): ProductProfitabilityData {
    return ProductProfitabilityDataToJSONTyped(json, false);
}

export function ProductProfitabilityDataToJSONTyped(value?: ProductProfitabilityData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'summary': ProductProfitabilitySummaryDataToJSON(value['summary']),
        'products': value['products'] == null ? undefined : ((value['products'] as Array<any>).map(ProductProfitabilityProductDataToJSON)),
        'topProductsByProfit': value['topProductsByProfit'] == null ? undefined : ((value['topProductsByProfit'] as Array<any>).map(ProductProfitabilityProductDataToJSON)),
        'topProductsByAmount': value['topProductsByAmount'] == null ? undefined : ((value['topProductsByAmount'] as Array<any>).map(ProductProfitabilityProductDataToJSON)),
        'page': value['page'],
        'limit': value['limit'],
        'totalItems': value['totalItems'],
        'totalPages': value['totalPages'],
        'sourceTotalItems': value['sourceTotalItems'],
        'loadedItems': value['loadedItems'],
        'isTruncated': value['isTruncated'],
        'mode': value['mode'],
        'sortBy': value['sortBy'],
        'marketingAllocationBasis': value['marketingAllocationBasis'],
    };
}

